import {User, Company, userMatchesSSOHubblFilters} from 'hubbl-shared';
import {EventDTO} from '../../models/event/EventDTO';

/**
 * Filters events based on publish date, user's department, office location, and other SSO properties
 * This ensures employees only see published events that are relevant to them
 */
export const filterEventsForUser = (
  events: EventDTO[],
  user: User,
  company?: Company | null,
): EventDTO[] => {
  const now = new Date();

  return events.filter(event => {
    // Check if event is published (marketingStartDate has passed)
    const marketingDate = event.marketingStartDate.toDate();
    if (marketingDate > now) {
      return false; // Event not yet published
    }

    // If event has no filters, it's visible to everyone (after publish date)
    if (!event.filters || event.filters.length === 0) {
      return true;
    }

    // Legacy department check
    if (
      event.filters.some(
        filter =>
          filter.type === 'department' && filter.id === user.department?.id,
      )
    ) {
      return true;
    }

    // SSO hierarchical filter check
    if (
      user.customSSOProperties &&
      company?.organizationalMetadata &&
      userMatchesSSOHubblFilters(
        user.customSSOProperties,
        event.filters,
        company.organizationalMetadata,
      )
    ) {
      return true;
    }

    // If user doesn't match any filters, hide the event
    return false;
  });
};
